module.exports = __webpack_public_path__ + "img/pic-sfgcs.03d9aed5.png";